import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from "@/views/HomeView";
import LoginView from "@/views/LoginView";
import ReservationListView from "@/views/ReservationListView";
import BuyTicketListView from "@/views/BuyTicketListView";
import TicketTypeListView from "@/views/TicketTypeListView";
import otherView from "@/views/otherView";
import CreateTicketTypeView from "@/views/CreateTicketTypeView";
import GetTicketTypeView from "@/views/GetTicketTypeView";
import UpdateTicketTypeView from "@/views/UpdateTicketTypeView";
import ReservationNumView from "@/views/ReservationNumView";
import ReservationSettingView from "@/views/ReservationSettingView";
import ProjectManagementView from "@/views/ProjectManagementView.vue";
import CreateContentView from "@/views/CreateContentView.vue"


Vue.use(VueRouter)

const routes = [
	   {
			path: '/',
			component: ReservationListView,
			meta: ['票务后台管理', '预约信息管理'],
		},
    // {
	// 	path: '/',
	// 	name:'login',
	// 	component: LoginView
	// },

    {
		path: '/manage',
		component: HomeView,
		name: '',
		meta: ['票务后台管理'],
		},
        //       {
		// 	path: '/reservationList',
		// 	component: ReservationListView,
		// 	meta: ['票务后台管理', '预约信息管理'],
		// },
	         {
			path: '/reservationNum',
			component: ReservationNumView,
			meta: ['票务后台管理', '预约信息管理','已预约时间段'],
		},
	         {
			path: '/reservationSetting',
			component: ReservationSettingView,
			meta: ['票务后台管理', '预约信息管理', '预约设置'],
		},
	{
			path: '/buyTicketList',
			component: BuyTicketListView,
			meta: ['票务后台管理', '购票信息管理'],
		},{
			path: '/ticketTypeList',
			component: TicketTypeListView,
			meta: ['票务后台管理', '票种管理'],
		},{
			path: '/createTicketType',
			component: CreateTicketTypeView,
			meta: ['票务后台管理', '新增票种'],
		},
	{
			path: '/createContent',
			component: CreateContentView,
			meta: ['票务后台管理', '新增内容'],
		},
			{
			path: '/updateTicketType',
			component: UpdateTicketTypeView,
			meta: ['票务后台管理', '修改票种'],
		},
			{
			path: '/getTicketType',
			component: GetTicketTypeView,
			meta: ['票务后台管理', '查看票种'],
		},
	{
			path: '/projectManagement',
			component: ProjectManagementView,
			meta: ['票务后台管理', '查看票种'],
		},
			{
			path: '/otherView',
			component: otherView,
			meta: ['票务后台管理', '其他功能'],
		}
	// 	]
	// }


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
